import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";

// import '../../Styles/TenantAdminUser.scss'
import "../../Styles/TenantCreateUsers.scss";
import Images from "../../Assets/Images";
import { Link, NavLink } from "react-router-dom";

import TenantCreatedFetchUser from "./TenantCreatedFetchUser";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../Action/Tenant/TenantCreatedFetchUser";

class TenantCreateUsers extends Component {
  constructor (props) {
    super(props);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const token =
        secureLocalStorage.getItem("loggedClient") == "user"
          ? secureLocalStorage.getItem("userKey")
          : secureLocalStorage.getItem("tenantKey");
const loggedClient=secureLocalStorage.getItem("loggedClient");
    if (nextProps.userDataFailure != null) {
      let key = secureLocalStorage.getItem("tenantKey");
      nextProps.history.push(`${loggedClient}/${token}`);
      // secureLocalStorage.clear();
      return { null: nextProps.actions.UserDataFailure(null) };
    }
    return null;
  }
  render() {
    let tenantKey = secureLocalStorage.getItem("tenantKey");
    const { loaderStatus } = this.props;
    return (
      <div className="appCont">
          <div className="dbCard card100 nopadd" >
            <div className="gridBox">
             

              <div className="tblCont UserList relPosition" style={ { paddingTop: '0px' } }>
                {/* SPINNER */ }
                { loaderStatus ? (
                  <span className="MatTableSpinner">
                    <CircularProgress style={ { color: "#FFFFFF" } } size={ 70 } />
                  </span>
                ) : null }


                <TenantCreatedFetchUser { ...this.props } />
              </div>
            </div>
          </div>
        
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => {
  return {
    loaderStatus: state.TenantCreatedFetchUser.loaderStatus,
    userDataFailure: state.TenantCreatedFetchUser.userDataFailure,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TenantCreateUsers);
